/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
import * as i0 from "@angular/core";
import * as i1 from "./close-button.component";
import * as i2 from "@angular/common";
import * as i3 from "./close-button.component.scss.shim.ngstyle";
var CloseButtonModuleNgFactory = i0.ɵcmf(i1.CloseButtonModule, [], function (_l) { return i0.ɵmod([i0.ɵmpd(512, i0.ComponentFactoryResolver, i0.ɵCodegenComponentFactoryResolver, [[8, []], [3, i0.ComponentFactoryResolver], i0.NgModuleRef]), i0.ɵmpd(4608, i2.NgLocalization, i2.NgLocaleLocalization, [i0.LOCALE_ID, [2, i2.ɵangular_packages_common_common_a]]), i0.ɵmpd(1073742336, i2.CommonModule, i2.CommonModule, []), i0.ɵmpd(1073742336, i1.CloseButtonModule, i1.CloseButtonModule, [])]); });
export { CloseButtonModuleNgFactory as CloseButtonModuleNgFactory };
var styles_CloseButtonComponent = [i3.styles];
var RenderType_CloseButtonComponent = i0.ɵcrt({ encapsulation: 0, styles: styles_CloseButtonComponent, data: {} });
export { RenderType_CloseButtonComponent as RenderType_CloseButtonComponent };
export function View_CloseButtonComponent_0(_l) { return i0.ɵvid(2, [(_l()(), i0.ɵeld(0, 0, null, null, 1, "button", [["aria-label", "Close"], ["type", "button"]], null, [[null, "click"]], function (_v, en, $event) { var ad = true; var _co = _v.component; if (("click" === en)) {
        var pd_0 = (_co.onClick() !== false);
        ad = (pd_0 && ad);
    } return ad; }, null, null)), (_l()(), i0.ɵeld(1, 0, null, null, 0, "i", [["class", "fa fa-times times-icon"]], null, null, null, null, null))], null, null); }
export function View_CloseButtonComponent_Host_0(_l) { return i0.ɵvid(0, [(_l()(), i0.ɵeld(0, 0, null, null, 1, "lp2-close-button", [], null, null, null, View_CloseButtonComponent_0, RenderType_CloseButtonComponent)), i0.ɵdid(1, 49152, null, 0, i1.CloseButtonComponent, [], null, null)], null, null); }
var CloseButtonComponentNgFactory = i0.ɵccf("lp2-close-button", i1.CloseButtonComponent, View_CloseButtonComponent_Host_0, {}, { click: "click" }, []);
export { CloseButtonComponentNgFactory as CloseButtonComponentNgFactory };
//# sourceMappingURL=close-button.component.ngfactory.js.map


//////////////////
// WEBPACK FOOTER
// ./ts/app/components/close-button/close-button.component.ngfactory.js
// module id = 390
// module chunks = 27 28 29